var _circle, _line, _line2, _line3, _line4, _line5, _line6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path, _circle14, _path2, _path3, _circle15, _path4, _path5, _circle16, _line7, _rect, _rect2, _rect3, _circle17, _rect4, _rect5, _circle18, _circle19, _line8, _line9, _circle20, _path6, _line10, _line11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 96,
    r: 66,
    stroke: "rgba(255,255,255,0.08)",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 96,
    x2: 160,
    y2: 30,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 96,
    x2: 217,
    y2: 63,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 96,
    x2: 217,
    y2: 129,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 96,
    x2: 160,
    y2: 162,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 96,
    x2: 103,
    y2: 129,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 96,
    x2: 103,
    y2: 63,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 96,
    r: 24,
    fill: "rgba(255,255,255,0.16)",
    stroke: "rgba(255,255,255,0.85)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 96,
    r: 12,
    fill: "none",
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 96,
    r: 4.5,
    fill: "rgba(255,255,255,0.9)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 72,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 79,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 96,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 113,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 113,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 96,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 79,
    r: 3.5,
    fill: "rgba(255,255,255,0.85)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 30,
    r: 18,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.72)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151 32 C151 30 153 28 156 28 C157 26 159 25 162 25 C166 25 169 28 169 31 C171 31 173 33 173 35 C173 37 171 38 169 38 H151 C149 38 147 36 147 34 C147 32 149 30 151 30",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 63,
    r: 18,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.72)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217 54 L209 58 L209 63 C209 69 212.5 73.5 217 75 C221.5 73.5 225 69 225 63 L225 58 Z",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214 63 L216.5 65.5 L221 60",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 129,
    r: 18,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.72)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211 123 L206 129 L211 135",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223 123 L228 129 L223 135",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 162,
    r: 18,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.72)",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 171,
    x2: 170,
    y2: 171,
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 165,
    width: 4,
    height: 6,
    rx: 1,
    fill: "rgba(255,255,255,0.65)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 159,
    width: 4,
    height: 12,
    rx: 1,
    fill: "rgba(255,255,255,0.9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 161,
    width: 4,
    height: 10,
    rx: 1,
    fill: "rgba(255,255,255,0.75)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 129,
    r: 18,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.72)",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 121,
    width: 20,
    height: 6.5,
    rx: 1.5,
    fill: "none",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 130,
    width: 20,
    height: 6.5,
    rx: 1.5,
    fill: "none",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 1.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 124.2,
    r: 1.8,
    fill: "rgba(255,255,255,0.85)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 133.2,
    r: 1.8,
    fill: "rgba(255,255,255,0.85)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 124.2,
    x2: 110,
    y2: 124.2,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 133.2,
    x2: 110,
    y2: 133.2,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 63,
    r: 18,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.72)",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53 C98 53 94 57 94 62 C94 66 96.5 69 100 70.5 L100 72 L106 72 L106 70.5 C109.5 69 112 66 112 62 C112 57 108 53 103 53 Z",
    stroke: "rgba(255,255,255,0.9)",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "rgba(255,255,255,0.08)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 73,
    x2: 106,
    y2: 73,
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 75,
    x2: 105,
    y2: 75,
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesHero);
export default __webpack_public_path__ + "static/media/services_hero.f4c5da88569c606f21336ac3bafba9c6.svg";
export { ForwardRef as ReactComponent };